// Real, verbatim client feedback pulled directly from the founder's public freelance
// profiles. Quotes are unedited except where noted; nothing here is invented.
// Source of truth: https://www.freelancer.in/u/officialravikuma
export const FREELANCER_PROFILE = {
  platform: 'Freelancer',
  url: 'https://www.freelancer.in/u/officialravikuma',
  rating: 5.0,
  reviewCount: 14,
  credential: 'Google Certified Digital Marketer: PPC | SEO',
  stats: [
    { label: 'On time', value: '100%' },
    { label: 'On budget', value: '100%' },
    { label: 'Accept rate', value: '93%' },
  ],
};

export const FREELANCER_REVIEWS = [
  {
    reviewer: 'Notarmon B.',
    rating: 5.0,
    project: 'Google Tag Manager + GA4 Expert for Full E-commerce Tracking Setup',
    // Trimmed to a verbatim excerpt so the founder's name is not shown on the page.
    // Wording and meaning are unchanged; nothing has been added or rephrased.
    quote:
      'Very professional, hands on, and has deep level of expertise. He helped bring our tracking and integrations to the next level. I would recommend him at any time.',
    tags: ['Google Tag Manager', 'GA4', 'Tracking', 'WordPress'],
    featured: true,
  },
  {
    reviewer: 'Zaynoodin R.',
    rating: 5.0,
    project: 'One Time Setup Google Ads',
    quote: 'We achieved outstanding results from our Google Ads campaign. The work was executed professionally and delivered exceptional performance.',
    tags: ['Google Ads', 'SEO'],
  },
  {
    reviewer: 'Kamil A.',
    rating: 5.0,
    project: 'GoHighLevel Funnel Expert Needed for Luxury Aesthetic Clinic (Meta Ads + Growth Hacking)',
    quote: 'Good work. On time, good communication skills, very respectful manners, perfect technical skills.',
    tags: ['Meta Ads', 'GoHighLevel', 'Growth Hacking'],
  },
  {
    reviewer: 'Chirag R.',
    rating: 5.0,
    project: 'B2B Restaurant Lead-Gen Calling',
    quote: 'Great guy! completed work on time and with professionalism. Trustworthy, fees justified!',
    tags: ['Lead Generation'],
  },
];

// Upwork blocks automated access to review text; per the same standard applied to the
// Freelancer profile (real evidence only, nothing invented), only the verifiable profile
// statistics are shown here, linked to the live profile for anyone to confirm directly.
export const UPWORK_PROFILE = {
  platform: 'Upwork',
  url: 'https://www.upwork.com/freelancers/~018efc1e272c62bd12',
  title: 'Google Ads Specialist | PPC Campaign Manager | Lead Generation Expert',
  rating: 4.7,
  reviewCount: 12,
  jobsCompleted: 13,
  hoursWorked: '1.4K',
};
